import React, { useEffect, useState } from "react";
import "./Dashboard.scss";
import Grid from "@mui/material/Unstable_Grid2";
import {
  Box,
  Button,
  Link,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";
import { Chart } from "react-google-charts";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import UGGraph from "../../../../Supporting files/UGGraph/UGGraph";
import Highcharts from "highcharts";
import Highcharts3D from "highcharts/highcharts-3d";
import HighchartsExporting from "highcharts/modules/exporting";
import HighchartsExportData from "highcharts/modules/export-data";
import HighchartsAccessibility from "highcharts/modules/accessibility";
import SearchDropdown from "../../../../Supporting files/SearchDropdown/SearchDropdown";

Highcharts3D(Highcharts);
HighchartsExporting(Highcharts);
HighchartsExportData(Highcharts);
HighchartsAccessibility(Highcharts);

interface Props {
  value_update: Function;
}

const Dashboard: React.FC<Props> = ({ value_update }) => {
  const [logintype, setLogintype] = useState<string | null>("endoresement");
  const [viewTabsStatus, setViewTabsStatus] = useState<string>("India");
  const [origin, setOrigin] = useState<string>("IN");
  const changeToggle = (
    event: React.MouseEvent<HTMLElement>,
    newchangeToggle: string | null
  ) => {
    if (newchangeToggle != null) {
      setLogintype(newchangeToggle);
    }
  };

  const policyRenewal = [
    {
      class_name: "health",
      title: "Health",
      value: "124",
    },
    {
      class_name: "term",
      title: "Term",
      value: "86",
    },
    {
      class_name: "ci",
      title: "CI",
      value: "12",
    },
    {
      class_name: "pa",
      title: "PA",
      value: "04",
    },
  ];
  const alertSummary = [
    {
      class_name: "claimicon",
      title: "Claim",
      value: "86",
    },
    {
      class_name: "endoreseicon",
      title: "Endorsement",
      value: "12",
    },
  ];

  const optionsPiChart = {
    is3D: true,
    legend: "none",
  };
  const totalClients = [
    ["Total Clients", "Hours per Day"],
    ["Engineering", 11],
    ["IT", 2],
    ["Design", 2],
    ["HR", 2],
    ["Accounts", 7],
  ];

  const data = [
    {
      name: "Jan",
      uv: 4000,
      pv: 2400,
      amt: 2400,
    },
    {
      name: "Feb",
      uv: 3000,
      pv: 1398,
      amt: 2210,
    },
    {
      name: "Mar",
      uv: 2000,
      pv: 9800,
      amt: 2290,
    },
    {
      name: "Apr",
      uv: 2780,
      pv: 3908,
      amt: 2000,
    },
    {
      name: "May",
      uv: 1890,
      pv: 4800,
      amt: 2181,
    },
    {
      name: "Jun",
      uv: 2390,
      pv: 3800,
      amt: 2500,
    },
    {
      name: "Jul",
      uv: 3490,
      pv: 4300,
      amt: 2100,
    },
  ];

  const dataRequest = [
    {
      name: "Jan",
      uv: 4000,
      pv: 2400,
      amt: 2400,
    },
    {
      name: "Feb",
      uv: 3000,
      pv: 1398,
      amt: 2210,
    },
    {
      name: "Mar",
      uv: 2000,
      pv: 9800,
      amt: 2290,
    },
    {
      name: "Apr",
      uv: 2780,
      pv: 3908,
      amt: 2000,
    },
    {
      name: "May",
      uv: 1890,
      pv: 4800,
      amt: 2181,
    },
    {
      name: "Jun",
      uv: 2390,
      pv: 3800,
      amt: 2500,
    },
    {
      name: "Jul",
      uv: 3490,
      pv: 4300,
      amt: 2100,
    },
  ];

  const [productType, setProductType] = useState<string | null>("all");
  const [graphData, setGraphData] = useState([
    {
      name: "Jan",
      a: 2000,
      b: 3000,
    },
    {
      name: "Feb",
      a: 7800,
      b: 8000,
    },
    {
      name: "Mar",
      a: 3400,
      b: 4400,
    },
    {
      name: "Apr",
      a: 9000,
      b: 10000,
    },
    {
      name: "May",
      a: 1200,
      b: 22000,
    },
    {
      name: "Jun",
      a: 4600,
      b: 5600,
    },
    {
      name: "Aug",
      a: 3400,
      b: 4400,
    },
    {
      name: "Sep",
      a: 9000,
      b: 10000,
    },
    {
      name: "Oct",
      a: 4500,
      b: 5500,
    },
    {
      name: "Nov",
      a: 7800,
      b: 8800,
    },
    {
      name: "Dec",
      a: 3500,
      b: 4500,
    },
  ]);
  const policyTypeData: (string | number)[][] = [
    ["Task", "Hours per Day"],
    ["Health", 6],
    ["Term", 2],
    ["PA", 9],
    ["CI", 11],
  ];
  const optionsDonutChart = {
    pieHole: 0.4,
    is3D: true,
    height: 400,
    legend: {
      position: "bottom",
      alignment: "center",
      textStyle: {
        color: "#666",
        fontSize: 12,
      },
    },
  };
  const premiumPolicyData: (string | number)[][] = [
    // ["Task", "Hours per Day"],
    ["Health", 1500],
    ["Term", 3000],
    ["Super Topup", 4000],
    ["Travel", 5000],
    ["Personal Accident", 6000],
    ["Critical Illness", 5500],
  ];
  const IndStates = [
    ["State", "Clients"],
    ["Andhra Pradesh", null],
    ["Arunachal Pradesh", null],
    ["Assam", null],
    ["Bihar", null],
    ["Chhattisgarh", 62],
    ["Goa", 58],
    ["Gujarat", 54],
    ["Haryana", 30],
    ["Himachal Pradesh", 35],
    ["Jharkhand", 41],
    ["Jammu and Kashmir", 20],
    ["Karnataka", null],
    ["Kerala", null],
    ["Madhya Pradesh", null],
    ["Maharashtra", null],
    ["Manipur", null],
    ["Meghalaya", null],
    ["Mizoram", 10],
    ["Nagaland", 38],
    ["Odisha", 45],
    ["Punjab", 40],
    ["Rajasthan", 68],
    ["Sikkim", 66],
    ["Tamil Nadu", 64],
    ["Telangana", null],
    ["Tripura", null],
    ["Uttar Pradesh", 54],
    ["Uttarakhand", 50],
    ["West Bengal", null],
    ["Delhi", 30],
  ];
  const optionsGeoChart = {
    region: origin, // Display US states
    domain: origin,
    displayMode: "regions",
    tooltip: { isHtml: true, trigger: "both" }, // Display tooltip on hover and selection
    resolution: "provinces", // Show state boundaries
    defaultColor: "#ffffff",
    regionStyle: {
      border: "1px solid #FFE1A7", // Set border style
      borderRadius: 20, // Set border radius
    },
    colorAxis: {
      colors: [
        "#e5ef88", // Light color, likely representing lower values.
        "#d4b114", // A middle color, representing intermediate values.
        "#e85a03", // Dark color, representing higher values.
      ],
    },
  };
  useEffect(() => {
    (Highcharts as any).chart("premium_policy_pie_chart", {
      chart: {
        type: "pie",
        options3d: {
          enabled: true,
          alpha: 40,
        },
      },
      plotOptions: {
        pie: {
          innerSize: 100,
          depth: 45,
        },
      },
      series: [
        {
          name: "Premium Amount",
          data: premiumPolicyData,
        },
      ],
      tooltip: {
        pointFormat: "<b>Rs.{point.y}</b>", // Display Rs. before each value in the tooltip
      },
    });
  }, []);
  const countryDropData = [
    { label: "IN", value: "IN" },
    { label: "US", value: "US" },
    { label: "CA", value: "CA" },
  ];
  const UsStates = [
    ["State", "Clients"],
    ["Alabama", 40],
    ["Alaska", null],
    ["American Samoa", 50],
    ["Arizona", null],
    ["Arkansas", 44],
    ["California", 22],
    ["Colorado", null],
    ["Connecticut", 36],
    ["Delaware", null],
    ["District Of Columbia", 50],
    ["Federated States Of Micronesia", 40],
    ["Florida", null],
    ["Georgia", null],
    ["Guam", null],
    ["Hawaii", 15],
    ["Idaho", 26],
    ["Illinois", null],
    ["Indiana", 38],
    ["Iowa", null],
    ["Kansas", 25],
    ["Kentucky", 35],
    ["Louisiana", null],
    ["Maine", 30],
    ["Marshall Islands", 40],
    ["Maryland", null],
    ["Massachusetts", null],
    ["Michigan", 10],
    ["Minnesota", null],
    ["Mississippi", 10],
    ["Missouri", 44],
    ["Montana", null],
    ["Nebraska", 45],
    ["Nevada", 33],
    ["New Hampshire", null],
    ["New Jersey", 22],
    ["New Mexico", null],
    ["New York", null],
    ["North Carolina", 10],
    ["North Dakota", 20],
    ["Northern Mariana Islands", null],
    ["Ohio", null],
    ["Oklahoma", 42],
    ["Oregon", 44],
    ["Palau", null],
    ["Pennsylvania", null],
    ["Puerto Rico", 50],
    ["Rhode Island", 30],
    ["South Carolina", null],
    ["South Dakota", null],
    ["Tennessee", null],
    ["Texas", null],
    ["Utah", null],
    ["Vermont", null],
    ["Virgin Islands", null],
    ["Virginia", null],
    ["Washington", null],
    ["West Virginia", null],
    ["Wisconsin", null],
    ["Wyoming", null],
  ];
  const CanadaStates = [
    ["State", "Clients"],
    ["Alberta", 12],
    ["British Columbia", 20],
    ["Manitoba", null],
    ["New Brunswick", null],
    ["Newfoundland and Labrador", 15],
    ["Nova Scotia", null],
    ["Northwest Territories", 5],
    ["Nunavut", null],
    ["Ontario", 24],
    ["Prince Edward Island", null],
    ["Québec", null],
    ["Saskatchewan", null],
    ["Yukon", null],
  ];
  const updateMasterState = (attrName: any, value: string) => {
    attrName(value);
  };

  return (
    <Grid container spacing={3}>
      <Grid xs={12}>
        <h3 className="mb-0">Dashboard</h3>
      </Grid>
      <Grid xs={8} xl={9} className="pl-0">
        <Grid container spacing={3}>
          <Grid xs={4}>
            <Grid
              container
              alignItems="center"
              className="totalClients"
              spacing={0}
            >
              <Grid xs={12} className="pl-4">
                <h3>1,086</h3>
                <p>Active Employees</p>
                <span className="charts">
                  <Chart
                    chartType="PieChart"
                    data={totalClients}
                    options={optionsPiChart}
                    width={"150px"}
                    height={"150px"}
                  />
                </span>
              </Grid>
            </Grid>
          </Grid>
          <Grid xs={4}>
            <Grid
              container
              alignItems="center"
              className="activePolicies"
              spacing={0}
            >
              <Grid xs={6} className="pl-4">
                <h3>4,946</h3>
                <p>Active Policies</p>
              </Grid>
              <Grid xs={6} className="pr-4">
                <ul>
                  <li className="health">Health</li>
                  <li className="term">Term</li>
                  <li className="ci">CI</li>
                  <li className="pa">PA</li>
                </ul>
              </Grid>
            </Grid>
          </Grid>
          <Grid xs={4}>
            <Grid container className="noofLives" spacing={0}>
              <Grid xs={12} className="totalLives">
                <img src="./images/noof_lives.png" />
                <span>
                  <h3>1,836</h3>
                  <p>No. of Lives</p>
                </span>
              </Grid>
              <Grid xs={6} className="pl-4">
                <h5>1,068</h5>
                <p>Employees</p>
              </Grid>
              <Grid xs={6} className="pl-4">
                <h5>768</h5>
                <p>Dependents</p>
              </Grid>
            </Grid>
          </Grid>
          <Grid container spacing={3} className="employerPolicyWrapper">
            <Grid xs={12}>
              <h4 className="mb-0">Policies</h4>
            </Grid>
            <Grid xs={5}>
              <div className="cyanPolicyCard">
                <Grid container className="employerpolicyDetail">
                  <Grid xs={8}>
                    <span className="active">Active</span>
                    <h5>Group Health Insurance</h5>
                    <p className="mb-4">Care for health plan</p>
                  </Grid>
                  <Grid xs={4} className="text-center">
                    <img
                      src="./images/insurerlogo/Royal_Sundaram.svg"
                      alt="img"
                    />
                  </Grid>
                  <Grid xs={4}>
                    <p className="small">Sum Insured</p>
                    <h6 className="rIcon">3L, 5L, 10L</h6>
                  </Grid>
                  <Grid xs={4} className="text-center">
                    <p className="small">Valid Till</p>
                    <h6>10/12/2026</h6>
                  </Grid>
                  <Grid xs={4} className="text-right">
                    <p className="small">Dependents</p>
                    <h6>2000</h6>
                  </Grid>
                </Grid>
                <div className="whitepart">
                  <div className="col">
                    <p className="small">CD Balance</p>
                    <h6 className="rIcon">5L</h6>
                  </div>
                  <div className="col">
                    <p className="small">Employees</p>
                    <h6>1,002</h6>
                  </div>
                  <div className="col">
                    <p className="small">Dependents</p>
                    <h6>2000</h6>
                  </div>
                  <p className="note">
                    * CD balance last updated on 01/06/2022
                  </p>
                </div>
              </div>
            </Grid>
            <Grid xs={5}>
              <div className="redPolicyCard">
                <Grid container className="employerpolicyDetail">
                  <Grid xs={8}>
                    <span className="inactive">Active</span>
                    <h5>Group Health Insurance</h5>
                    <p className="mb-4">Care for health plan</p>
                  </Grid>
                  <Grid xs={4} className="text-center">
                    <img src="./images/insurerlogo/Appolo.svg" alt="img" />
                  </Grid>
                  <Grid xs={4}>
                    <p className="small">Sum Insured</p>
                    <h6 className="rIcon">3L, 5L, 10L</h6>
                  </Grid>
                  <Grid xs={4} className="text-center">
                    <p className="small">Valid Till</p>
                    <h6>10/12/2026</h6>
                  </Grid>
                  <Grid xs={4} className="text-right">
                    <p className="small">Dependents</p>
                    <h6>2000</h6>
                  </Grid>
                </Grid>
                <div className="whitepart">
                  <div className="col">
                    <p className="small">CD Balance</p>
                    <h6 className="rIcon">5L</h6>
                  </div>
                  <div className="col">
                    <p className="small">Employees</p>
                    <h6>1,002</h6>
                  </div>
                  <div className="col">
                    <p className="small">Dependents</p>
                    <h6>2000</h6>
                  </div>
                </div>
              </div>
            </Grid>
            <Grid xs={12}>
              <h4 className="mt-5">No. of Lives</h4>
              <UGGraph data={graphData} product_type={productType} />
            </Grid>
          </Grid>
          <Grid xs={12} xl={6} textAlign={"center"}>
            <Box
              borderRadius={5}
              padding={3}
              sx={{ background: "rgba(107, 98, 220, 0.1)" }}
            >
              <h4 className="mb-0">Policy Type as %</h4>
              <span className="policytypeas">
                <Chart
                  chartType="PieChart"
                  width="100%"
                  height="400px"
                  data={policyTypeData}
                  options={optionsDonutChart}
                />
              </span>
              <div
                style={{
                  textAlign: "center",
                  color: "#8e8e93",
                  fontWeight: 600,
                }}
              >
                Total Policies - 4946
              </div>
            </Box>
          </Grid>
          <Grid xs={12} xl={6} textAlign={"center"}>
            <Box
              borderRadius={5}
              padding={3}
              sx={{ background: "rgba(107, 98, 220, 0.1)" }}
            >
              <h4 className="mb-0">Premium Policy </h4>
              <span className="policytypeas">
                <div id="premium_policy_pie_chart"></div>
              </span>
              <div
                style={{
                  textAlign: "center",
                  color: "#8e8e93",
                  fontWeight: 600,
                }}
              >
                Total Premium Rs. 23500
              </div>
            </Box>
          </Grid>

          <Grid xs={12}>
            <Box>
              <Grid container alignItems="center">
                <Grid xs={12} padding={0}>
                  <h4 className="mb-0 pb-3">
                    Branch Geographical Represention
                  </h4>
                </Grid>
                <Grid xs={12} lg={5} xl={4} className="pl-0">
                  <div className="productTabs ">
                    <Button
                      style={{ padding: "10px 30px" }}
                      className={
                        viewTabsStatus == "India"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        setViewTabsStatus("India");
                        setOrigin("IN");
                      }}
                    >
                      India
                    </Button>
                    <Button
                      style={{ padding: "10px 30px" }}
                      className={
                        viewTabsStatus == "World"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        setViewTabsStatus("World");
                      }}
                    >
                      Different Region
                    </Button>
                  </div>
                </Grid>
                {viewTabsStatus == "World" ? (
                  <Grid xs={12} lg={4} xl={3} className="pl-0">
                    <SearchDropdown
                      class_name="inputField"
                      title="Choose Country"
                      value={origin}
                      attrName={setOrigin}
                      value_update={updateMasterState}
                      data={countryDropData}
                      warn_status={false}
                      error_message="Please select client"
                    />
                  </Grid>
                ) : null}
              </Grid>
              {viewTabsStatus == "India" ? (
                <>
                  <span className="policytypea">
                    <Chart
                      chartType="GeoChart"
                      width="100%"
                      data={IndStates}
                      options={optionsGeoChart}
                    />
                  </span>
                </>
              ) : null}
              {viewTabsStatus == "World" ? (
                <>
                  <span className="policytypea">
                    <Chart
                      chartType="GeoChart"
                      width="100%"
                      data={
                        origin === "US"
                          ? UsStates
                          : origin === "CA"
                          ? CanadaStates
                          : IndStates
                      }
                      options={optionsGeoChart}
                    />
                  </span>
                </>
              ) : null}
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={3} className="mt-15">
          <Grid xs={6}>
            <h4 className="mb-0">Requests</h4>
          </Grid>
          <Grid xs={6} className="text-right">
            <ToggleButtonGroup
              className="loginTypeToggle"
              value={logintype}
              size="small"
              exclusive
              onChange={changeToggle}
            >
              <ToggleButton value="claim">Claim</ToggleButton>
              <ToggleButton value="endoresement">Endorsement</ToggleButton>
            </ToggleButtonGroup>
          </Grid>
          <Grid xs={12}>
            <ResponsiveContainer width="100%" height={400}>
              <BarChart
                barSize={15}
                data={dataRequest}
                margin={{
                  top: 20,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="pv" stackId="a" fill="#847DD6" />
                <Bar dataKey="amt" stackId="a" fill="#66D1BD" />
              </BarChart>
            </ResponsiveContainer>
          </Grid>
        </Grid>
      </Grid>

      <Grid xs={4} xl={3}>
        <Grid container spacing={3}>
          <Grid xs={12}>
            <div className="alertMessage">
              <InfoIcon />
              <h5>Did you know?</h5>
              <p>Your CD balance is low.</p>
              <Link>
                <CloseIcon />
              </Link>
            </div>
          </Grid>
          <Grid xs={12} className="todolist mb-0">
            <h4>To Do</h4>
            <Link underline="none" className="addpolicy">
              Upload employees
            </Link>
            <Link underline="none" className="riskscore">
              Complete company profile to share policies
            </Link>
            <Link underline="none" className="familyprofile">
              Review Access Controls
            </Link>
          </Grid>
          {/* <Grid xs={12}>
            <Box className="policyRenewal">
              <div className="thisMonth">This Month</div>
              <h3>486</h3>
              <p>Policies for Renewal</p>
              <ul>
                {policyRenewal.map((data, index) => (
                  <li className={data.class_name}>
                    <span>{data.value}</span> {data.title}
                  </li>
                ))}
              </ul>
            </Box>
          </Grid> */}
          <Grid xs={12}>
            <Box className="alertSummary">
              <h3>Alert Summary</h3>
              <p>Total pendings of claim & endorsement.</p>
              <ul>
                {alertSummary.map((data, index) => (
                  <li>
                    <div className={data.class_name}></div>
                    <p>
                      {data.title} <span>{data.value}</span>
                    </p>
                  </li>
                ))}
              </ul>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Dashboard;
